const Store = () => {
  return <>매장 운영</>;
};
export default Store;
